import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import linkify from 'linkify';
import Settings from '~/settings.js';

import GeneralView from '~/generalView';
import template from '~/templates/tickets.handlebars';

var TickettView = GeneralView.View.extend({
	tagName: "div",
	className: 'ticket',
	troubleImage: null,
	filescont: null,
	initialize: function() {
		var that = this;
		this.listenTo(EventHub, 'renderTickets', () => {
			that.startUp();
		});
		this.listenTo(EventHub, 'clearTickets', () => {
			that.clearTroubleshooting();
		});
	},
	events: {
		'click #ticketsModal': 'clearNavigation',
		'change #uploadticket' : 'uploadFile',
		'click .discardicon' : 'discardfile',
		'click #sendtroublebtn' : 'sendTroubleshooting'
	},
	
	render: function () {
		this.startUp();
	},
	
	startUp: function(){
		var handlebarsTemplate = Handlebars.template(template);
		this.$el.html(handlebarsTemplate({
			user: Parse.User.current()
		}));
		this.translate();
		$('#troubleContactSupport').linkify();
	},
	
	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				  $(this).text(arrlang[lang][$(this).attr("key")]);
			});
		}
    },
	
	clearTroubleshooting: function() {
		this.$('#troubleshootingTitle').val(null);
		this.$('#troubleshootingText').val(null);
		this.$('#uploadticket').val(null);
		$('#ticketloadfilestext').hide();
		$('#ticketloadfilesspin').hide();
		$('#filenameticket').empty();
		this.filescont = 0;
		this.troubleImage = null;
	},
	
	clearNavigation: function() {
		setTimeout(function() {
			if($('#ticketsModal').is(':hidden')){
				$('#open_troubleshooting').removeClass('active');
			}
		}, 400);
	},
	
	discardfile: function(e){
		if(!e.currentTarget.classList.contains("icon_trash")){
			e.currentTarget.remove();
			this.filescont--;
			this.troubleImage = null;
		}
	},
	
	uploadFile: function(e){
  		var that = this;
  		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'File_'+this.filescont+extension;
		$('#filenameticket').fadeIn();
		$('#filenameticket').empty();
		$('#filenameticket').append("<div class='action remove-report discardicon' id='"+name+"' title='Descartar archivo'> <i class='fa fa-trash discardicon icon_trash'></i> "+ name +"</div>");
		$(".discardicon").hover(function(){
			if(!$(this).hasClass('icon_trash')){
				$(this).css("color", "#2F4F4F ");
				$(this).css("cursor", "pointer");
				$(this).css("border", "solid 1px");
				$(this).css("border-radius", "5px");
				$('.icon_trash', this).css("display", "inline");
			}
		}, 
		function(){
			$(this).css("color", "inherit");
			$(this).css("border", "initial");
			$('.icon_trash', this).css("display", "none");
		});
		reader.onload = function (e) {
  			var byteArray = new Uint8Array(e.target.result);
  			var output = new Array(byteArray.length);
  			var i = 0;
  			var n = output.length;
  			while (i < n) {
  				output[i] = byteArray[i];
  				i++;
  			}
  			var parseFile = new Parse.File(name, output);
  			that.troubleImage = parseFile;
  		};
  		reader.readAsArrayBuffer(e.target.files[0]);
	},
	
	sendTroubleshooting: function() {
		var that = this;
		var troubleTitle = $('#troubleshootingTitle').val();
		var troubleText = $('#troubleshootingText').val();
		var troubleImage = this.troubleImage;
		this.troubleImage = null;
		var userEmail = Parse.User.current().attributes.email;
		if(troubleTitle && troubleText) {
			$('#ticketloadfilestext').show();
			$('#ticketloadfilesspin').show();
			var files = null;
			if(troubleImage != null){
				files = [{
					name: troubleImage._name,
					base64: troubleImage._source.base64
				}];
			}
			Parse.Cloud.run("SendTicket", { 'title': troubleTitle, 'content': troubleText, 'files': files,  'userId': Parse.User.current().id, 'userEmail': userEmail, 'supportClientId': Settings.supportClientId }).then(function(result) {
				that.clearTroubleshooting();
				toastr.success(arrlang[lang]["confirmsendtroubleshooting"],"Operación realizada");
			},
			function(error){
				that.clearTroubleshooting();
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
					default:
						toastr.error(arrlang[lang]['SendTicketError'],'Error');
					break;
				}
			});
		}
		else{
			toastr.error(arrlang[lang]["Errortroubleshooting"],"Error");
		}
	}
});
export default TickettView;
